/** Locale-aware month / weekday labels via Intl (no hardcoded English). */
export function monthShortLabel(month1to12: number, locale: string, year = 2026): string {
  try {
    return new Intl.DateTimeFormat(locale, { month: "short" }).format(
      new Date(year, month1to12 - 1, 1)
    );
  } catch {
    return String(month1to12);
  }
}

export function monthLongLabel(month1to12: number, locale: string, year = 2026): string {
  try {
    return new Intl.DateTimeFormat(locale, { month: "long" }).format(
      new Date(year, month1to12 - 1, 1)
    );
  } catch {
    return String(month1to12);
  }
}

/** Weekday short labels starting Monday (Mon…Sun) — common EU calendar layout. */
export function weekdaysMonFirst(locale: string): string[] {
  const fmt = new Intl.DateTimeFormat(locale, { weekday: "short" });
  // 2024-01-01 was Monday
  return Array.from({ length: 7 }, (_, i) =>
    fmt.format(new Date(2024, 0, 1 + i))
  );
}

/** Weekday short labels starting Sunday (Sun…Sat) — US layout. */
export function weekdaysSunFirst(locale: string): string[] {
  const fmt = new Intl.DateTimeFormat(locale, { weekday: "short" });
  // 2023-12-31 was Sunday
  return Array.from({ length: 7 }, (_, i) =>
    fmt.format(new Date(2023, 11, 31 + i))
  );
}

/** Prefer Mon-first for es and most non-en; Sun-first for en-* */
export function weekdaysForLocale(locale: string): string[] {
  const base = locale.split("-")[0]?.toLowerCase() ?? "en";
  return base === "en" ? weekdaysSunFirst(locale) : weekdaysMonFirst(locale);
}

export function calendarStartsOnMonday(locale: string): boolean {
  return (locale.split("-")[0]?.toLowerCase() ?? "en") !== "en";
}
